import { useTranslation } from 'react-i18next'
import CampusesPageContent from '../components/pages/CampusesPageContent'
import PageMeta from '../components/seo/PageMeta'
import { PageSlugs } from '../constants/pageSlugs'

export default function CampusesPage() {
  const { t } = useTranslation()
  const title = t('campusesPage.heroTitle')
  const excerpt = t('campusesPage.heroExcerpt')

  return (
    <article className="header-offset">
      <PageMeta title={title} description={excerpt} path={`/pages/${PageSlugs.campuses}`} />

      <div className="relative overflow-hidden gradient-brand py-16 text-white sm:py-20">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -end-20 top-0 h-64 w-64 rounded-full bg-accent blur-3xl" />
        </div>
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-accent">
            {t('campusesPage.heroLabel')}
          </p>
          <h1 className="text-4xl font-bold sm:text-5xl">{title}</h1>
          {excerpt && (
            <p className="mx-auto mt-4 max-w-2xl text-lg text-white/80">{excerpt}</p>
          )}
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
        <CampusesPageContent />
      </div>
    </article>
  )
}
